/* eslint react/no-multi-comp: 0 */
import React, { useState } from 'react';
import dayjs from 'dayjs';

import {
    DateRangePicker,
    lastNDays,
    type DateRangeLabels,
    type DateRangeSpec,
} from '@ui/components';

const labels: DateRangeLabels = {
    lastNDays: days => `Last ${days} Days`,
    today: 'Today',
    to: 'to',
    endBeforeStart: 'End date must not be before start date',
};

export const DefaultDateRangePickerExample = () => {
    const [value, setValue] = useState<DateRangeSpec | null>(lastNDays(30));

    return (
        <DateRangePicker
            labels={labels}
            maxDate={dayjs()}
            onChange={setValue}
            value={value}
        />
    );
};

export const EndTodayDateRangePickerExample = () => {
    const [value, setValue] = useState<DateRangeSpec | null>({
        start: {
            type: 'fixed',
            value: dayjs().subtract(40, 'day').format('YYYY-MM-DD'),
        },
        end: { type: 'dynamic', value: 0 },
    });

    return (
        <DateRangePicker
            labels={labels}
            maxDate={dayjs()}
            onChange={setValue}
            value={value}
        />
    );
};

export const FixedDateRangePickerExample = () => {
    const [value, setValue] = useState<DateRangeSpec | null>({
        start: { type: 'fixed', value: '2026-08-01' },
        end: { type: 'fixed', value: '2026-10-01' },
    });

    return (
        <DateRangePicker
            labels={labels}
            maxDate={dayjs()}
            onChange={setValue}
            value={value}
        />
    );
};

export const CustomPresetsDateRangePickerExample = () => {
    const [value, setValue] = useState<DateRangeSpec | null>(lastNDays(14));

    return (
        <DateRangePicker
            labels={labels}
            maxDate={dayjs()}
            onChange={setValue}
            presets={[14, 90]}
            value={value}
        />
    );
};

export const EmptyDateRangePickerExample = () => {
    const [value, setValue] = useState<DateRangeSpec | null>(null);

    return (
        <DateRangePicker
            labels={labels}
            maxDate={dayjs()}
            onChange={setValue}
            value={value}
        />
    );
};

export const DisabledDateRangePickerExample = () => (
    <DateRangePicker
        disabled
        labels={labels}
        onChange={() => undefined}
        value={lastNDays(7)}
    />
);
